<script setup lang="ts">
import { PRESENTER_VALUE_FALLBACK } from './presenterValueFallback';

defineOptions({ inheritAttrs: false });

withDefaults(
  defineProps<{
    text?: string;
  }>(),
  { text: PRESENTER_VALUE_FALLBACK }
);
</script>

<template>
  <span class="text__color-text-disabled" style="font: inherit" v-bind="$attrs">
    <slot name="default" :text="PRESENTER_VALUE_FALLBACK">
      {{ text }}
    </slot>
  </span>
</template>
